var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3360_108387)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.9778 3.37088L10.0003 7.34835L6.02287 3.37087C5.5348 2.88281 4.74317 2.88281 4.2551 3.37087L3.37122 4.25476C2.88315 4.74283 2.88315 5.53446 3.37122 6.02252L7.34869 10L3.37122 13.9775C2.88315 14.4655 2.88315 15.2572 3.37122 15.7452L4.2551 16.6291C4.74317 17.1172 5.5348 17.1172 6.02287 16.6291L10.0003 12.6517L13.9778 16.6291C14.4659 17.1172 15.2575 17.1172 15.7456 16.6291L16.6295 15.7452C17.1175 15.2572 17.1175 14.4655 16.6295 13.9775L12.652 10L16.6295 6.02253C17.1175 5.53446 17.1175 4.74283 16.6295 4.25476L15.7456 3.37087C15.2575 2.88281 14.4659 2.88281 13.9778 3.37088Z",
    fill: "#E04D43"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3360_108387"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.953db7f4774d2708c7da86b01374fc77.svg";
export { ForwardRef as ReactComponent };